import { MessageRetailerOrBrandButton, additionalDataRequiredForContactingRetailerOrBrandCTA } from "../../shared/instantAnswerUtils";
import { getDeliveredAtDateFromIAContext } from "../../utils/getDeliveredAtDateFromIAContext";
import { orderCanBeReportedBasedOnDeliveryDate } from "../../utils/orderCanBeReportedBasedOnDeliveryDate";
import { DO_NOT_PROCESS_DAMAGED_AS_RETURN, INELIGIBLE_FOR_REPORT, NEED_MORE_INFO_ANSWER, getReportItemsOrRequestExtensionCTA } from "./shared";
export var ReportWrongItemIA = function ReportWrongItemIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getReportItemsOrRequ;
        return (_getReportItemsOrRequ = getReportItemsOrRequestExtensionCTA(context, strictLocalize)) === null || _getReportItemsOrRequ === void 0 ? void 0 : _getReportItemsOrRequ.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getReportItemsOrRequ2, _getReportItemsOrRequ3;
        return (_getReportItemsOrRequ2 = getReportItemsOrRequestExtensionCTA(context, strictLocalize)) === null || _getReportItemsOrRequ2 === void 0 ? void 0 : (_getReportItemsOrRequ3 = _getReportItemsOrRequ2.getLink) === null || _getReportItemsOrRequ3 === void 0 ? void 0 : _getReportItemsOrRequ3.call(_getReportItemsOrRequ2, context.brandOrder);
      }
    },
    secondaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _MessageRetailerOrBra;
        return (_MessageRetailerOrBra = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra === void 0 ? void 0 : _MessageRetailerOrBra.label;
      },
      onClickFunctionBuilder: function onClickFunctionBuilder(context) {
        var _MessageRetailerOrBra2;
        return (_MessageRetailerOrBra2 = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra2 === void 0 ? void 0 : _MessageRetailerOrBra2.onClick;
      }
    },
    additionalRequiredData: additionalDataRequiredForContactingRetailerOrBrandCTA()
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  var brandOrder = context.brandOrder,
    shippingContext = context.shippingContext;
  var deliveredAt = getDeliveredAtDateFromIAContext(context);
  if (!brandOrder || !shippingContext || !deliveredAt) {
    return NEED_MORE_INFO_ANSWER(strictLocalize);
  }
  return orderCanBeReportedBasedOnDeliveryDate(deliveredAt) ? WRONG_ITEM_REPORT_ELIGIBLE(strictLocalize) : WRONG_ITEM_REPORT_INELIGIBLE(strictLocalize);
};
var WRONG_ITEM_REPORT_ELIGIBLE = function WRONG_ITEM_REPORT_ELIGIBLE(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return RESOLVING_INCORRECT_ITEMS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [MESSAGE_BRAND_ABOUT_YOUR_ITEMS(strictLocalize)];
    }
  };
};
var WRONG_ITEM_REPORT_INELIGIBLE = function WRONG_ITEM_REPORT_INELIGIBLE(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return INELIGIBLE_FOR_REPORT(strictLocalize);
    },
    getDescription: function getDescription() {
      return [MESSAGE_BRAND_TO_LEARN_MORE_OR_REQUEST_EXTENSION(strictLocalize), DO_NOT_PROCESS_DAMAGED_AS_RETURN(strictLocalize)];
    }
  };
};
var RESOLVING_INCORRECT_ITEMS = function RESOLVING_INCORRECT_ITEMS(strictLocalize) {
  return strictLocalize({
    id: "plWRu8",
    defaultMessage: [{
      "type": 0,
      "value": "Résolution des articles incorrects"
    }]
  });
};
var MESSAGE_BRAND_ABOUT_YOUR_ITEMS = function MESSAGE_BRAND_ABOUT_YOUR_ITEMS(strictLocalize) {
  return strictLocalize({
    id: "HCDK1w",
    defaultMessage: [{
      "type": 0,
      "value": "Vous pouvez envoyer un message à la marque à propos de vos articles ou un rapport en utilisant le bouton ci-dessous."
    }]
  });
};
var MESSAGE_BRAND_TO_LEARN_MORE_OR_REQUEST_EXTENSION = function MESSAGE_BRAND_TO_LEARN_MORE_OR_REQUEST_EXTENSION(strictLocalize) {
  return strictLocalize({
    id: "KC1x+u",
    defaultMessage: [{
      "type": 0,
      "value": "Envoyez un message à la marque pour en savoir plus ou demandez une prolongation en cas de circonstances exceptionnelles."
    }]
  });
};